const benefits = [
  {
    id: 'prevencion',
    tag: '01',
    title: 'Prevención',
    shortDesc: 'Detección temprana, menos invasión',
    description:
      'Las visitas periódicas permiten detectar y tratar enfermedades bucodentales en etapas tempranas, evitando así tratamientos más invasivos y costosos en el futuro.',
    bullets: [
      'Revisión y diagnóstico completo',
      'Limpieza profesional profunda',
      'Radiografías de control',
      'Aplicación de flúor preventivo',
    ],
    image:
      'https://readdy.ai/api/search-image?query=dental%20prevention%20tooth%20cleaning%20toothbrush%20illustration%20colorful%20bright%20professional%20dental%20care%20hygiene%20blue%20background%20clean%20health%20concept%20medical%20infographic%20style&width=480&height=340&seq=mfbenefit01&orientation=landscape',
    accentColor: 'bg-[#3A86FF]',
    lightColor: 'bg-[#3A86FF]/8',
    borderColor: 'border-[#3A86FF]/20',
    tagColor: 'text-[#3A86FF]',
    iconBg: 'from-[#3A86FF]/20 to-[#0A2540]/10',
    icon: 'ri-shield-check-line',
    iconColor: 'text-[#3A86FF]',
  },
  {
    id: 'operatoria',
    tag: '02',
    title: 'Operatoria',
    shortDesc: 'Tratamientos restauradores precisos',
    description:
      'Según el diagnóstico, el dentista recomendará el tratamiento restaurador más adecuado para preservar y devolver la función y estética de tus dientes.',
    bullets: [
      'Resinas estéticas de alta resistencia',
      'Incrustaciones de porcelana',
      'Tratamiento de conductos (endodoncia)',
      'Reconstrucciones dentales',
      'Corona y puente fijo',
    ],
    image:
      'https://readdy.ai/api/search-image?query=dental%20operatory%20treatment%20tooth%20filling%20restoration%20dental%20tools%20instruments%20illustration%20green%20teal%20background%20colorful%20professional%20medical%20dental%20procedure&width=480&height=340&seq=mfbenefit02&orientation=landscape',
    accentColor: 'bg-emerald-500',
    lightColor: 'bg-emerald-500/8',
    borderColor: 'border-emerald-500/20',
    tagColor: 'text-emerald-500',
    iconBg: 'from-emerald-500/20 to-emerald-900/10',
    icon: 'ri-first-aid-kit-line',
    iconColor: 'text-emerald-500',
  },
  {
    id: 'cirugia',
    tag: '03',
    title: 'Cirugía',
    shortDesc: 'Intervenciones con la máxima precisión',
    description:
      'Según la severidad del diagnóstico, el dentista recomendará el procedimiento quirúrgico adecuado para resolver el problema de raíz con el menor malestar posible.',
    bullets: [
      'Extracciones quirúrgicas complejas',
      'Cirugía de terceros molares (muelas del juicio)',
      'Curetaje y cirugía periodontal',
      'Alargamiento de corona clínica',
    ],
    image:
      'https://readdy.ai/api/search-image?query=dental%20surgery%20extraction%20tooth%20procedure%20illustration%20orange%20peach%20background%20colorful%20professional%20dental%20surgical%20tools%20medical%20art%20concept&width=480&height=340&seq=mfbenefit03&orientation=landscape',
    accentColor: 'bg-amber-500',
    lightColor: 'bg-amber-500/8',
    borderColor: 'border-amber-500/20',
    tagColor: 'text-amber-500',
    iconBg: 'from-amber-500/20 to-amber-900/10',
    icon: 'ri-surgical-mask-line',
    iconColor: 'text-amber-500',
  },
  {
    id: 'rehabilitacion',
    tag: '04',
    title: 'Rehabilitación',
    shortDesc: 'Recupera función, armonía y estética',
    description:
      'Ayuda a mejorar la salud bucal integral, mejorando y recuperando la función masticatoria, la armonía oclusal y la estética bucodental de forma duradera.',
    bullets: [
      'Implante dental de titanio',
      'Prótesis fija y removible',
      'Ortodoncia y alineadores',
      'Férulas miorelajantes (bruxismo)',
    ],
    image:
      'https://readdy.ai/api/search-image?query=dental%20rehabilitation%20implant%20prosthesis%20orthodontics%20braces%20tooth%20illustration%20purple%20lavender%20background%20colorful%20professional%20medical%20dental%20art%20concept&width=480&height=340&seq=mfbenefit04&orientation=landscape',
    accentColor: 'bg-violet-500',
    lightColor: 'bg-violet-500/8',
    borderColor: 'border-violet-500/20',
    tagColor: 'text-violet-500',
    iconBg: 'from-violet-500/20 to-violet-900/10',
    icon: 'ri-award-line',
    iconColor: 'text-violet-500',
  },
];

export default function BenefitsSection() {
  return (
    <section id="benefits" className="py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20 scroll-animate">
          <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
            ¿Por qué visitar al dentista?
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0A2540] mb-5 leading-tight">
            Beneficios de ir a Consulta con un{' '}
            <span className="bg-gradient-to-r from-[#3A86FF] to-[#0A2540] bg-clip-text text-transparent">
              Dentista · Odontólogo
            </span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto font-light leading-relaxed">
            Una visita regular al dentista va mucho más allá de una simple limpieza.
            Conoce las áreas en las que podemos ayudarte a mantener y recuperar tu salud bucal.
          </p>
        </div>

        {/* Cards — alternating layout */}
        <div className="space-y-10">
          {benefits.map((b, i) => (
            <div
              key={b.id}
              className={`group flex flex-col ${
                i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-0 rounded-3xl overflow-hidden border ${b.borderColor} scroll-animate anim-delay-${i * 100} hover:-translate-y-1 transition-all duration-300`}
              style={{ boxShadow: '0 4px 40px rgba(10,37,64,0.06)' }}
            >
              {/* Image half */}
              <div className="lg:w-2/5 relative overflow-hidden" style={{ minHeight: '280px' }}>
                <img
                  src={b.image}
                  alt={`Dentista ${b.title} MF Dental`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  style={{ minHeight: '280px' }}
                />
                {/* Overlay gradient */}
                <div
                  className={`absolute inset-0 ${
                    i % 2 === 0
                      ? 'bg-gradient-to-r from-transparent to-white/20'
                      : 'bg-gradient-to-l from-transparent to-white/20'
                  }`}
                />
                {/* Tag badge */}
                <div className="absolute top-5 left-5">
                  <span className={`${b.accentColor} text-white font-bold text-xs px-3 py-1.5 rounded-full`}>
                    {b.tag}
                  </span>
                </div>
              </div>

              {/* Content half */}
              <div className={`lg:w-3/5 ${b.lightColor} p-10 flex flex-col justify-center`}>
                {/* Icon + title */}
                <div className="flex items-center gap-4 mb-4">
                  <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br ${b.iconBg} rounded-2xl border ${b.borderColor} flex-shrink-0`}>
                    <i className={`${b.icon} ${b.iconColor} text-2xl`} />
                  </div>
                  <div>
                    <span className={`${b.tagColor} text-xs font-semibold tracking-widest uppercase`}>
                      Área {b.tag}
                    </span>
                    <h3 className="text-[#0A2540] font-extrabold text-2xl leading-tight">
                      {b.title}
                    </h3>
                  </div>
                </div>

                {/* Short desc pill */}
                <div className={`inline-flex items-center gap-2 ${b.lightColor} border ${b.borderColor} rounded-full px-4 py-1.5 mb-5 w-fit`}>
                  <div className={`w-1.5 h-1.5 rounded-full ${b.accentColor} flex-shrink-0`} />
                  <span className="text-[#0A2540] text-xs font-medium">{b.shortDesc}</span>
                </div>

                {/* Description */}
                <p className="text-gray-600 text-base leading-relaxed mb-7">
                  {b.description}
                </p>

                {/* Bullets */}
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                  {b.bullets.map((bullet) => (
                    <li key={bullet} className="flex items-center gap-3">
                      <div className={`w-5 h-5 flex items-center justify-center ${b.accentColor} rounded-md flex-shrink-0`}>
                        <i className="ri-check-line text-white text-xs" />
                      </div>
                      <span className="text-gray-600 text-sm">{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center scroll-animate">
          <p className="text-gray-400 text-sm mb-5">
            ¿No sabes qué tipo de tratamiento necesitas? <strong className="text-[#0A2540]">Nosotros te orientamos.</strong>
          </p>
          <a
            href="tel:5534748982"
            className="inline-flex items-center gap-2 bg-[#0A2540] hover:bg-[#0d3060] text-white px-8 py-4 rounded-full font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line" />
            </div>
            Llama y recibe orientación gratuita
          </a>
        </div>
      </div>
    </section>
  );
}
